import React, { useEffect } from 'react';
import { Animated, StyleSheet, Text, View } from 'react-native';

import { lowerDisplayLineTestIDs, Theme } from '@constants';
import { useShowNextLDLProduct, useTomorrowForecast } from '@hooks';

import { roundNearest5 } from '../../../helpers/DataFormatting';
import { getForecastWeatherPhrase } from '../../../helpers/getWeatherPhrase';
import { TWCAnimatedIcon } from '../../primitives/TWCAnimatedIcon/TWCAnimatedIcon';
import { TWCText } from '../../primitives/TWCText/TWCText';

const testIDPath = lowerDisplayLineTestIDs.tomorrow;

const LDLTomorrowAPI = () => {
  const data = useTomorrowForecast();
  const showNextProduct = useShowNextLDLProduct();

  useEffect(() => {
    data.length === 0 && showNextProduct(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return data.length > 0 ? <LDLTomorrowUI data={data[0]} onFinish={showNextProduct} /> : <></>;
};

const LDLTomorrowUI = ({
  data: {
    snowForecasted,
    daypartName,
    iconCodeExtend,
    temperatureHigh,
    temperatureLow,
    precipChance,
    precipType,
    snowRange,
  },
  onFinish,
}) => {
  useEffect(() => {
    const animation = Animated.timing(new Animated.Value(0), {
      duration: 5000,
      useNativeDriver: true,
    });

    animation.start(({ finished }) => finished && onFinish?.());
    return animation.reset;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const precipChanceRounded = roundNearest5(precipChance);
  const weatherPhrase = getForecastWeatherPhrase({ iconCodeExtend });
  const precipTypeFormatted = precipType
    ? precipType[0].toUpperCase() + precipType.slice(1) // capitalize first letter
    : '';
  const precipText = precipChance ? `${precipChanceRounded}% Chance of ${precipTypeFormatted}` : '';
  const snowRangeText = snowRange ? `${snowRange}" Snow Accumulation` : '';

  return (
    <>
      <TWCText style={styles.productText} testID={testIDPath.productLabel} variant={'condensedText36Transparent'}>
        {daypartName ? daypartName : ''}
      </TWCText>
      <TWCAnimatedIcon code={iconCodeExtend} />
      <View style={styles.itemText}>
        <Text>
          <TWCText testID={testIDPath.temperatureHigh} variant={'condensedText36'}>
            {temperatureHigh ? `${temperatureHigh}°` : ''}
            {temperatureHigh && temperatureLow ? '/' : ''}
          </TWCText>
          <TWCText style={styles.temperatureLow} testID={testIDPath.temperatureLow} variant={'condensedText36'}>
            {temperatureLow ? `${temperatureLow}°` : ''}
          </TWCText>
        </Text>
      </View>
      <TWCText style={styles.itemText} testID={testIDPath.weatherPhrase} variant={'condensedText36'}>
        {weatherPhrase ? weatherPhrase : ''}
      </TWCText>
      <TWCText style={styles.itemText} testID={testIDPath.precipChance} variant={'condensedText36'}>
        {snowForecasted ? snowRangeText : precipText}
      </TWCText>
    </>
  );
};

export const LDLTomorrow = {
  API: LDLTomorrowAPI,
  UI: LDLTomorrowUI,
};

const styles = StyleSheet.create({
  itemText: {
    paddingLeft: Theme.px(18),
    paddingRight: Theme.px(42),
  },
  pageWrapper: {
    flexDirection: 'row',
    position: 'absolute',
  },
  productText: {
    paddingRight: Theme.px(48),
  },
  temperatureLow: {
    color: Theme.malibuBlue,
  },
});
